module.exports = "../images/icons/credit-card.svg";